import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2dfb25e0")

_pushScopeId("data-v-2dfb25e0")
const _hoisted_1 = { id: "replicaSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Template ID", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "label heading" }, "Position", -1)
const _hoisted_5 = { class: "settings-row" }
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { class: "label normalCase" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "componentIdInput",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.idWatcher = val => (_ctx.component.targetId = val))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.component.targetId = $event))
      }, null, 544), [
        [_vModelText, _ctx.component.targetId]
      ])
    ]),
    _createVNode("p", {
      class: ["label", 
        _ctx.components[_ctx.component.targetId] &&
        _ctx.components[_ctx.component.targetId].displayName == 'Template'
          ? ''
          : 'red-text'
      ]
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.component.targetId]
          ? " NOT FOUND!"
          : _ctx.components[_ctx.component.targetId].displayName != "Template"
          ? " is not a Template"
          : ": " + _ctx.components[_ctx.component.targetId].name), 3),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.component.position.x = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.position.x,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_7
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.component.position.y = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.position.y,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_9
      ])
    ]),
    _hoisted_10,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.templateData, (data, i) => {
      return (_openBlock(), _createBlock("div", {
        key: i,
        class: "settings-row"
      }, [
        _createVNode("span", _hoisted_11, "#" + _toDisplayString(data.name) + " = ", 1),
        (typeof data.value == 'number')
          ? _withDirectives((_openBlock(), _createBlock("input", {
              key: 0,
              type: "number",
              "onUpdate:modelValue": $event => (data.value = $event)
            }, null, 8, ["onUpdate:modelValue"])), [
              [
                _vModelText,
                data.value,
                void 0,
                { number: true }
              ]
            ])
          : _withDirectives((_openBlock(), _createBlock("input", {
              key: 1,
              type: "text",
              "onUpdate:modelValue": $event => (data.value = $event)
            }, null, 8, ["onUpdate:modelValue"])), [
              [_vModelText, data.value]
            ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})